import React from 'react';
import { createPortal } from 'react-dom';
import { tokens } from '../../styles/tokens';
import { useTheme } from '../../context/ThemeContext';
import { formatRestaurantPrice } from '../../utils/formatPrice';

export function CartBar({ itemCount, total, onOpen, onWaiter, currency = 'UZS' }) {
  const theme = useTheme();
  const { colors, isDark } = theme;

  if (itemCount === 0) return null;

  const bar = (
    <div
      style={{
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)',
      maxWidth: 430,
      zIndex: 5000,
      padding: '10px 0',
      paddingBottom: 'max(10px, env(safe-area-inset-bottom, 0px))',
      boxSizing: 'border-box',
      background: isDark
        ? 'linear-gradient(to top, #0A0A0A 70%, transparent)'
        : 'linear-gradient(to top, #F5F5F5 70%, transparent)',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    }}
    >

      <button
        onClick={onOpen}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '13px 16px',
          borderRadius: tokens.radius.lg,
          backgroundColor: colors.accent,
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          fontFamily: tokens.font.family,
          boxShadow: '0 4px 20px rgba(48,129,246,0.35)',
          minWidth: 0,
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexShrink: 0,
        }}>
          <span style={{ fontSize: '20px', lineHeight: 1 }}>🛒</span>
          <span style={{
            backgroundColor: 'rgba(255,255,255,0.25)',
            borderRadius: '100px',
            padding: '2px 8px',
            fontSize: '13px',
            fontWeight: '700',
          }}>
            {itemCount}
          </span>
        </div>

        <span style={{
          fontSize: '15px',
          fontWeight: '700',
          flexShrink: 0,
        }}>
          {formatRestaurantPrice(total, currency)}
        </span>
      </button>

      <button
        onClick={onWaiter}
        style={{
          width: '50px',
          height: '50px',
          borderRadius: tokens.radius.lg,
          backgroundColor: colors.bgChip,
          border: 'none',
          fontSize: '20px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
        aria-label="Вызвать официанта"
      >🛎️</button>

    </div>
  );

  return createPortal(bar, document.body);
}
